module.exports = __webpack_public_path__ + "fixed.a027bcb.png";